import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FlexGrid } from '@grapecity/wijmo.grid';

import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW2400Model } from './kymw2400.model';
import { SectionTemplateModel } from './vo/section-template.model';
import { PageTemplateWindowComponent } from '../page-template-window/page-template-window.component';
import { SectionTemplateComponent } from '../page-template-window/section-template.component';

import { KYMW2401Component } from '../kymw2401/kymw2401.component';
import { KYMW2403Component } from '../kymw2403/kymw2403.component';

import { CancelDataService } from './api-services/cancel-data.service';
import { DeleteSectionService } from './api-services/delete-section.service';
import { DeleteTemplateService } from './api-services/delete-template.service';
import { GetAllPageTemplateService } from './api-services/get-all-page-template.service';
import { GetPageTemplateInfoService } from './api-services/get-page-template-info.service';
import { RegistNewTemplateService } from './api-services/regist-new-template.service';
import { SelectSectionService } from './api-services/select-section.service';
import { UpdateTemplateService } from './api-services/update-template.service';
import { NewSectionModel } from './vo/new-section.model';
import { FunctionMenuService } from 'src/app/commons/kymw02/function-menu/function-menu.service';
import { FMenu } from 'src/app/commons/kymw02/function-menu/fmenu';

/**
 * ページパターン設定画面を管理するクラス
 *
 * @export KYMW2400Component
 * @class KYMW2400Component
 */
@Component({
  selector: 'app-kymw2400',
  templateUrl: 'kymw2400.component.html',
  styleUrls: ['kymw2400.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW2400Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('btn_NewTemplate', { static: true }) btn_NewTemplate: ElementRef;
  @ViewChild('btn_EditTemplate', { static: true }) btn_EditTemplate: ElementRef;
  @ViewChild('dtg_PageTemplateList', { static: true }) dtg_PageTemplateList: FlexGrid;
  @ViewChild('tw_pagePattern', { static: true }) tw_pagePattern: PageTemplateWindowComponent;
  @ViewChild('btn_NewPageRegist', { static: true }) btn_NewPageRegist: ElementRef;
  @ViewChild('btn_DeleteTemplate', { static: true }) btn_DeleteTemplate: ElementRef;

  private readonly ALLLIST: number = 0;
  private readonly NEWPAGE: number = 1;
  private readonly EDITPAGE: number = 2;
  private readonly CANCEL: number = 3;

  /**
   * 更新可能/閲覧モード
   * "true"：閲覧のみ　　"false"：更新可能
   */
  private readOnly: string = null;

  public readonly PANEL_HEIGHT: number = 255;
  public readonly PANEL_HEIGHT_FULL: number = 540;
  public readonly GRID_HEIGHT: number = 220;
  public readonly GRID_HEIGHT_FULL: number = 460;
  public gridHeight: number = this.GRID_HEIGHT;

  public kymw2400Model: KYMW2400Model = new KYMW2400Model();

  /**
   *Creates an instance of KYMW2400Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {CancelDataService} cancelDataService
   * @param {DeleteSectionService} deleteSectionService
   * @param {DeleteTemplateService} deleteTemplateService
   * @param {GetAllPageTemplateService} getAllPageTemplateService
   * @param {GetPageTemplateInfoService} getPageTemplateInfoService
   * @param {RegistNewTemplateService} registNewTemplateService
   * @param {SelectSectionService} selectSectionService
   * @param {UpdateTemplateService} updateTemplateService
   * @memberof KYMW2400Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private cancelDataService: CancelDataService,
    private deleteSectionService: DeleteSectionService,
    private deleteTemplateService: DeleteTemplateService,
    private getAllPageTemplateService: GetAllPageTemplateService,
    private getPageTemplateInfoService: GetPageTemplateInfoService,
    private registNewTemplateService: RegistNewTemplateService,
    private selectSectionService: SelectSectionService,
    private updateTemplateService: UpdateTemplateService,
    private fmenuService: FunctionMenuService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW2400Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2400';
    this.kymw2400Model.kymw2400Component = this;

    // 更新可能/閲覧モードを取得
    if (this.kymw00Model.kymw1001Model.formReadOnlyMode.has(this.componentName) === true) {
      this.readOnly = this.kymw00Model.kymw1001Model.formReadOnlyMode.get(this.componentName).toString();
    } else {
      this.readOnly = this.kymw00Model.kymw1001Model.topFuncReadOnlyMode.toString();
    }

    // 初期のボタン活性状態を設定
    if (this.readOnly === 'true') {
      // ボタン「テンプレート追加」
      this.kymw2400Model.disabledNewTemplate = true;
      // ボタン「テンプレート編集」
      this.kymw2400Model.disabledEditTemplate = true;
    } else {
      // ボタン「テンプレート追加」
      this.kymw2400Model.disabledNewTemplate = false;
      // ボタン「テンプレート編集」
      this.kymw2400Model.disabledEditTemplate = false;
    }

    // テンプレート一覧取得
    this.getAllPageTemplateService.execute(this.kymw2400Model);

    // グリッド初期処理
    this.gridInit();

    // メニューバー初期設定
    this.initMenuBar();

    this.dtg_PageTemplateList.focus();
  }

  /**
   * グリッド初期処理
   *
   * @private
   * @memberof KYMW2400Component
   */
  private gridInit() {
    // 一覧データ変更時
    this.dtg_PageTemplateList.itemsSourceChanged.addHandler((s, e) => {
      this.dtg_PageTemplateList.select(-1, -1);
      this.getPage().clear();
    });
  }

  /**
   * メニューバー設定処理
   *
   * @private
   * @memberof KYMW2400Component
   */
  private initMenuBar(): void {
    // ［表示］メニューを作成します
    const menuEdit = new FMenu('#menuEdit', {
      // header: '編集',
      header: '表示',
      displayMemberPath: 'header',
      selectedValuePath: 'menuID',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '最新情報に更新', menuID: 'mni_Reload' },
      ],
      // イベント設定
      itemClicked: () => {
        this.eventMenuBar_CHANGEHandler(menuEdit);
      }
    });

    this.fmenuService.menus = [ menuEdit ];
  }

  /*--------------------------------------------------------------------------------------------
  /* event area
  /*--------------------------------------------------------------------------------------------*/

  /**
   * メニューバーイベントリスナ
   */
  public eventMenuBar_CHANGEHandler(e: FMenu): void {
    switch (e.selectedItem.menuID) {
      // 最新情報に更新
      case 'mni_Reload':
        // ページテンプレート一覧取得
        this.getAllPageTemplateService.execute(this.kymw2400Model);
        break;
      default:
    }
  }

  /**
   * 【テンプレート一覧】 内の項目をクリック時イベント
   *
   * @memberof KYMW2400Component
   */
  public eventPageTemplateListHandler(): void {
    if (this.dtg_PageTemplateList.selection.row !== -1) {
        const targetIndex: number = this.kymw2400Model.pageTemplateList.findIndex(
          pageTemplate => pageTemplate.PageTemplateName === this.dtg_PageTemplateList.selectedItems[0].PageTemplateName);
      this.getPageTemplateInfoService.execute(this.kymw2400Model, targetIndex);
    }
  }

  /**
   * テンプレート一覧データ変更時
   *
   * @memberof KYMW2400Component
   */
  public bindPageTemplateDataHandler(): void {
    // ページを描画する
    this.showPage();
  }

  /**
   * ページ描画処理
   *
   * @private
   * @memberof KYMW2400Component
   */
  private showPage(): void {
    const pageTemplateData: any = this.kymw2400Model.pageTemplateData;
    const pageTemplate: PageTemplateWindowComponent = this.getPage();

    // ページデータ設定
    pageTemplate.setData(pageTemplateData);
  }

  /**
   * 新規追加テンプレートデータ変更時処理
   *
   * @memberof KYMW2400Component
   */
  public bindNewTemplateDataHandler(): void {
    if (this.kymw2400Model.newTemplateData != null) {
      this.changeViewStack(this.NEWPAGE);
    }
  }

  /**
   * テンプレート編集ボタン押下時
   *
   * @memberof KYMW2400Component
   */
  public eventEditTemplateHandler(): void {
    if (this.dtg_PageTemplateList.selection.row === -1) {
      // {0}を選択してください
      this.dialogService.openAlertGetMessage('E0148', ['テンプレート']);
    } else {
      // 遷移先画面で編集時のみ小数点以下も表示させるため
      // テンプレート新規作成時は小数点以下不要
      // リプレース開発時に基本的には画面表示時に小数点フォーマットをかけるようにしたが、
      // リプレース前と同じ挙動とするため仕方なく処理を入れている
      if (!this.kymw2400Model.selectedPageInfo.PageAreaX.includes('.')) {
        this.kymw2400Model.selectedPageInfo.PageAreaX = this.kymw2400Model.selectedPageInfo.PageAreaX + '.0';
      }
      if (!this.kymw2400Model.selectedPageInfo.PageAreaY.includes('.')) {
        this.kymw2400Model.selectedPageInfo.PageAreaY = this.kymw2400Model.selectedPageInfo.PageAreaY + '.0';
      }
      if (!this.kymw2400Model.selectedPageInfo.PageAreaWidth.includes('.')) {
        this.kymw2400Model.selectedPageInfo.PageAreaWidth = this.kymw2400Model.selectedPageInfo.PageAreaWidth + '.0';
      }
      if (!this.kymw2400Model.selectedPageInfo.PageAreaHeight.includes('.')) {
        this.kymw2400Model.selectedPageInfo.PageAreaHeight = this.kymw2400Model.selectedPageInfo.PageAreaHeight + '.0';
      }

      this.changeViewStack(this.EDITPAGE);
    }
  }

  /**
   * 閉じるボタン押下時処理(新規画面)
   *
   * @memberof KYMW2400Component
   */
  public eventCancelHandler(): void {
    this.changeViewStack(this.CANCEL);
  }

  /**
   * テンプレート追加処理
   *
   * @memberof KYMW2400Component
   */
  public eventNewPageRegistHandler(): void {
    this.registNewTemplateService.execute(this.kymw2400Model, this.getPage().createPageTemplateVO());
    this.changeViewStack(this.ALLLIST);
  }

  /**
   * テンプレート追加ボタン押下時処理
   *
   * @memberof KYMW2400Component
   */
  public eventNewPageCreateHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW2401Component);
    const instance = componentRef.componentInstance as KYMW2401Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * セクション追加ボタン押下時処理
   *
   * @memberof KYMW2400Component
   */
  public eventCreateNewSectinHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW2403Component);
    const instance = componentRef.componentInstance as KYMW2403Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * セクション削除ボタン押下時処理
   *
   * @memberof KYMW2400Component
   */
  public eventDeleteSectionHandler(): void {
    if (this.kymw2400Model.selectedSectionInfo.sectionTemplateID != null) {
      const sectionName: string = this.kymw2400Model.selectedSectionInfo.sectionTemplateName;

      // {0}を削除します。よろしいですか？
      this.dialogService.openAlertGetMessage(
        'Q0106',
        [sectionName],
        (closeDetail) => {
          this.nextEventDeleteSectionHandler(closeDetail);
        }
      );
    } else {
      // {0}を選択してください
      this.dialogService.openAlertGetMessage('E0148', ['セクション']);
    }
  }

  /**
   * セクション削除処理
   *
   * @param {number} closeDetail
   * @memberof KYMW2400Component
   */
  public nextEventDeleteSectionHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // 削除に成功したらtrue
      let deleteFlag = Boolean(false);
      const page: PageTemplateWindowComponent = this.getPage();
      for (let i = Number(0); i < page.sectionList.length; i++) {
        if (page.sectionList[i].selected) {
          deleteFlag = true;
          page.sectionList.splice(i, 1);
          page.reDraw();
          this.deleteSectionService.execute(this.kymw2400Model);
          break;
        }
      }
    }
  }

  /**
   * このテンプレートを削除ボタン押下時処理
   *
   * @memberof KYMW2400Component
   */
  public eventDeleteHandler(): void {
    // {0}を削除します。よろしいですか？
    this.dialogService.openAlertGetMessage(
      'Q0106',
      ['このテンプレート'],
      (closeDetail) => {
        this.nextEventDeleteHandler(closeDetail);
      }
    );
  }

  /**
   * テンプレート削除処理
   *
   * @private
   * @param {number} closeDetail
   * @memberof KYMW2400Component
   */
  public nextEventDeleteHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      this.deleteTemplateService.execute(this.kymw2400Model);
      this.changeViewStack(this.ALLLIST);
    }
  }

  /**
   * 確認ボタン押下時処理(編集画面)
   *
   * @memberof KYMW2400Component
   */
  public eventEditPageUpdateHandler(): void {
    // {0}を更新します。よろしいですか？
    this.dialogService.openAlertGetMessage(
      'Q0108',
      ['このテンプレート'],
      (closeDetail) => {
        this.nextEventEditPageUpdateHandler(closeDetail);
      }
    );
  }

  /**
   * 確認ボタン押下時、確認メッセージ表示後処理(編集画面)
   *
   * @private
   * @param {number} closeDetail
   * @memberof KYMW2400Component
   */
  public nextEventEditPageUpdateHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      this.updateTemplateService.execute(this.kymw2400Model, this.getPage().createPageTemplateVO());
      this.changeViewStack(this.ALLLIST);
    }
  }

  /**
   * テンプレート名存在チェック
   *
   * @param {string} checkTemplateName
   * @returns {boolean}
   * @memberof KYMW2400Component
   */
  public hasTemplateName(checkTemplateName: string): boolean {
    for (let i = Number(0); i < this.kymw2400Model.pageTemplateList.length; i++) {
      if (this.kymw2400Model.pageTemplateList[i].PageTemplateName === checkTemplateName) {
        return true;
      }
    }
    return false;
  }

  /**
   * 新規セクション追加
   *
   * @param {NewSectionModel} vo
   * @memberof KYMW2400Component
   */
  public addSection(vo: NewSectionModel): void {
    const newSection: SectionTemplateComponent = this.getPage().createEmptySection(vo);
    if (newSection != null) {
      this.getPage().sectionList.push(newSection);
      this.getPage().reDraw();
    } else {
      // セクションを配置するスペースがありません
      this.dialogService.openAlertGetMessage('E0136');
    }
  }

  /**
   * セクション選択時処理
   *
   * @memberof KYMW2400Component
   */
  public sectionClickHandler(): void {
    const page: PageTemplateWindowComponent = this.getPage();
    const section: SectionTemplateComponent = page.selectedSection();

    let vo: SectionTemplateModel = section.createSectionTemplateVO();
    vo = page.completeSectionTemplateVO(vo);

    this.selectSectionService.execute(this.kymw2400Model, vo);
  }

  /**
   * ページ取得
   *
   * @private
   * @returns {PageTemplateWindowComponent}
   * @memberof KYMW2400Component
   */
  private getPage(): PageTemplateWindowComponent {
    return this.tw_pagePattern;
  }

  /**
   * 画面モード切替
   *
   * @param {number} viewNumber
   * @memberof KYMW2400Component
   */
  public changeViewStack(viewNumber: number): void {
    this.kymw2400Model.hiddenAllListFlg = true;
    this.kymw2400Model.hiddenNewPageFlg = true;
    this.kymw2400Model.hiddenEditPageFlg = true;
    switch (viewNumber) {

      case (this.ALLLIST):
        this.kymw2400Model.hiddenAllListFlg = false;
        this.getPage().editable = false;
        break;

      case (this.CANCEL):
        this.kymw2400Model.hiddenAllListFlg = false;
        this.dtg_PageTemplateList.select(-1, -1);
        this.tw_pagePattern.clear();
        this.cancelDataService.execute(this.kymw2400Model);
        this.getPage().editable = false;
        break;

      case (this.NEWPAGE):
        this.kymw2400Model.hiddenNewPageFlg = false;
        this.getPage().editable = true;
        break;

      case (this.EDITPAGE):
        this.kymw2400Model.hiddenEditPageFlg = false;
        this.getPage().editable = true;
        break;

      default:
        break;
    }
  }

  public nextFocus(event: any): void {
    // 次項目移動の場合（Shiftキー押下時は逆移動の為、制御しない）
    if (event.keyCode === 9 && !event.shiftKey) {
      event.preventDefault();
      // ページテンプレート一覧はページテンプレートグリッドへフォーカス移動
      if (!this.kymw2400Model.hiddenAllListFlg) {
        this.dtg_PageTemplateList.focus();
        return;
      }
      // ページテンプレート新規作成は「確認」へフォーカス移動
      if (!this.kymw2400Model.hiddenNewPageFlg) {
        this.btn_NewPageRegist.nativeElement.focus();
        return;
      }
      // ページテンプレート編集は「このテンプレートを削除」へフォーカス移動
      if (!this.kymw2400Model.hiddenEditPageFlg) {
        this.btn_DeleteTemplate.nativeElement.focus();
        return;
      }
    }
  }
}
